// extracted by mini-css-extract-plugin
export default {"Vzdelanie":"Vzdelanie_Vzdelanie__d2DuU","content":"Vzdelanie_content__7Ithe","podNadpisom":"Vzdelanie_podNadpisom__9RZ1B"};